import AppError from '../libraries/AppError';
const PrunePredicateEnum = {
    INCLUDE: 1,
    INCLUDE_AND_PRUNE_CHILDREN: 2,
    EXCLUDE_AND_FLATTEN_CHILDREN: 3,
    EXCLUDE_AND_PRUNE_CHILDREN: 4,
};
const OrderLineOperators = {
    PrunePredicateEnum: PrunePredicateEnum,
    prune(orderLines, predicate) {
        function recurse(orderLine, newSubLineArray) {
            const pruneDecision = predicate(orderLine);
            if (pruneDecision === PrunePredicateEnum.INCLUDE) {
                const newOrderLine = Object.assign(Object.assign({}, orderLine), { subLines: [] });
                newSubLineArray.push(newOrderLine);
                if (orderLine.subLines && orderLine.subLines.length > 0) {
                    orderLine.subLines.forEach((line) => recurse(line, newOrderLine.subLines));
                }
            }
            else if (pruneDecision === PrunePredicateEnum.EXCLUDE_AND_FLATTEN_CHILDREN) {
                orderLine.subLines.forEach((line) => recurse(line, newSubLineArray));
            }
            else {
                throw AppError.CodingError()
                    .addData('pruneDecision', pruneDecision)
                    .addData('orderLine', orderLine.name + ' ' + orderLine.id);
            }
        }
        const newOrderLines = [];
        orderLines.forEach((line) => recurse(line, newOrderLines));
        return newOrderLines;
    },
};
export default OrderLineOperators;
